<template>
    <b-modal scrollable b-modal title="Nuova Fattura" ref="mdlFatturazione" id="mdlFatturazione" size="md" @ok="onSalvaRichiesta" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Mese Anno:</label>
                <b-input-group class="mb-3">
                    <date-picker format="MM-YYYY" value-type="timestamp" v-model="jsonData.meseAnnoRiferimento" type="month" :disabled-date="notAfter"></date-picker>
                </b-input-group>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Presidio:</label>
                <b-form-select v-model="jsonData.idStruttura" :value="null" value-field="id" text-field="denominazione" class="mb-2 mr-sm-2 mb-sm-0" :options="presidiOptions" @change="onChangePresidio"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Setting:</label>
                <b-form-select v-model="jsonData.idSetting" :value="null" value-field="id" text-field="setting" class="mb-2 mr-sm-2 mb-sm-0" :options="settingOptions"></b-form-select>
            </b-col>
        </b-row>
        <modal-error ref="cmpModalError"> </modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: { DatePicker, ModalError },
    data() {
        return {
            listKey: 0,
            pathResource: "/rsafatturazionerichieste",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceSetting: "/rsasettingspresidi",
            nominativo: "",
            id: null,
            jsonData: { meseAnnoRiferimento: null, idStruttura: null, idSetting: null },
            presidiOptions: [{ id: null, denominazione: "-Seleziona Valore-" }],
            settingOptions: [{ id: null, setting: "-Seleziona Valore-" }],
        };
    },
    mounted() {},

    watch: {},
    methods: {
        loadPresidi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, null, me.loadPresidiSuccess, me.loadPresidiError);
        },
        loadPresidiSuccess(response) {
            let me = this;
            me.presidiOptions = response.data.data.list;
            me.presidiOptions.unshift({ id: null, denominazione: "-Seleziona Valore-" });
            me.$emit("afterLoadData");
            me.listKey++;
        },
        loadPresidiError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onChangePresidio() {
            let me = this;
            me.loadSetting();
        },
        loadSetting() {
            let me = this;
            let filtro = { idPresidio: me.jsonData.idStruttura };
            UtilityMixin.methods.loadDataResources(me.pathResourceSetting, filtro, me.loadSettingSuccess, me.loadSettingError);
        },
        loadSettingSuccess(response) {
            let me = this;
            me.settingOptions = response.data.data.list;
            me.settingOptions.unshift({ id: null, setting: "-Seleziona Valore-" });
            me.$emit("afterLoadData");
            me.listKey++;
        },
        loadSettingError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        notAfter: function (date) {
            return date > Date.now();
        },
        show() {
            let me = this;
            me.loadPresidi();
            // me.loadSetting();
            me.jsonData = { meseAnnoRiferimento: null, idStruttura: null, idSetting: null };
            me.$refs.mdlFatturazione.show();
        },
        close() {
            let me = this;
            me.jsonData = { meseAnnoRiferimento: null, idStruttura: null, idSetting: null };
            me.$refs.mdlFatturazione.hide();
        },
        onClickUndo() {
            let me = this;
            me.$refs.mdlFatturazione.hide();
        },
        onSalvaRichiesta(bvModalEvent) {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultResponse, me.resultError);
            bvModalEvent.preventDefault();
        },
        resultResponse() {
            let me = this;
            me.$refs.mdlFatturazione.hide();
            me.$emit("afterSave");
        },
        resultError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
